module.exports = __webpack_public_path__ + "n1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/resources/screenshots/n1.png
// module id = 63
// module chunks = 0